import {
  useMutation,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '../../../constant/api';
import { api } from '../../../utils/api';

export interface FileActionIntervalRequest {
  historyId: string;
  records: Record<string, number>;
}

export const fileActionInterval = ({
  historyId,
  records,
}: FileActionIntervalRequest) => {
  const pages = Object.entries(records).map(([key, value]) => ({
    page: Number(key),
    stayed_time: value,
  }));

  return api.post<ApiResponse<undefined>>('/file/action/interval', {
    historyId,
    pages,
  });
};

export const fileBulkActionInterval = ({
  historyId,
  records,
}: FileActionIntervalRequest) => {
  return api.post<ApiResponse<undefined>>('/v2/viewer/interval', {
    historyId,
    records,
  });
};

const useFileActionInterval = <TError = AxiosError<ApiErrorResponse>>(
  isBulk = false,
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<undefined>>,
    TError,
    FileActionIntervalRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse<undefined>>,
  TError,
  FileActionIntervalRequest,
  QueryKey
> => {
  return useMutation(isBulk ? fileBulkActionInterval : fileActionInterval, {
    ...options,
  });
};

export default useFileActionInterval;
